export default function Testimonials() {
  const reviews = [
    {
      id: 1,
      title: "Najlepsze źródło spreadsheetów!",
      text: "Dzięki Kakobuy Spreadsheet znalazłem dokładnie te produkty, których szukałem. Listy są zawsze aktualne, a kategorie przejrzyście posegregowane. Polecam każdemu, kto szuka sprawdzonych okazji zakupowych.",
      author: "Marek K.",
      role: "Użytkownik od 2024",
    },
    {
      id: 2,
      title: "Ogromna oszczędność czasu",
      text: "Przeglądanie dziesiątek stron w poszukiwaniu produktów było koszmarem. Z Kakobuy Finds wszystko mam w jednym miejscu. Spreadsheety są szczegółowe i pomocne.",
      author: "Anna W.",
      role: "Regularna klientka",
    },
    {
      id: 3,
      title: "Świetne porównania platform",
      text: "Bardzo doceniam tabele porównawcze między Kakobuy, CSSBuy i Superbuy. Pomogły mi wybrać najlepszą platformę do moich potrzeb zakupowych.",
      author: "Piotr S.",
      role: "Nowy użytkownik",
    },
    {
      id: 4,
      title: "Wszystko jasno wyjaśnione",
      text: "Artykuły i poradniki są napisane w sposób zrozumiały nawet dla początkujących. Dowiedziałem się jak bezpiecznie korzystać ze spreadsheetów.",
      author: "Kasia M.",
      role: "Użytkowniczka od 2025",
    },
  ];

  return (
    <section className="py-16 md:py-24 px-4 md:px-6 lg:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-12 md:mb-16">
          <div className="flex items-center gap-3 mb-2">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs font-medium text-foreground-400 tracking-widest uppercase">
              Społeczność
            </span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight mb-3">
            Co mówią nasi użytkownicy
          </h2>
          <p className="text-sm text-foreground-500">
            Opinie osób, które korzystają z Kakobuy Spreadsheet na co dzień
          </p>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {reviews.map((review) => (
            <div
              key={review.id}
              className="bg-background-50 rounded-lg p-6 md:p-7"
            >
              {/* Stars */}
              <div className="flex items-center gap-0.5 mb-4 text-accent-500">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>

              {/* Title */}
              <h3 className="text-base font-semibold text-foreground-900 mb-3">
                {review.title}
              </h3>

              {/* Text */}
              <p className="text-sm text-foreground-500 leading-relaxed mb-5">
                {review.text}
              </p>

              {/* Author */}
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-full bg-foreground-300 flex items-center justify-center text-background-50 text-xs font-semibold">
                  {review.author.charAt(0)}
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-800">
                    {review.author}
                  </p>
                  <p className="text-xs text-foreground-400">
                    {review.role}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}